import { createSignal, ErrorBoundary, For, Show, onCleanup } from 'solid-js';
import Button from '#src/client/common/interactive/Button.jsx';
import BtnHome from '#src/client/common/icons/BtnHome.jsx';
import BtnLogout from '#src/client/common/icons/BtnLogout.jsx';
import Items from '#src/client/common/layout/Items.jsx';
import style from '#src/client/members/common/layout/Shell.module.css';
import { genRequest } from '#src/client/common/utils/browser/fetchHelper.js';
import RenderingErrorModal from '#src/client/common/errors/RenderingErrorModal.jsx';
import Notifications from '#src/client/common/notifications/Notifications.jsx';
import { addNotificationErrors, dismissAllNotificationErrors } from '#src/client/common/notifications/NotificationsDirector.jsx';

function mobileLayout(){

    const [isMobile, setIsMobile] = createSignal(window.innerWidth < 700);

    const handler = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', handler);
    onCleanup(() => window.removeEventListener('resize', handler));

    return isMobile;

}

function UserInfo(props) {

    return (
        <Show when={props.state.username || props.state.urlLogout}>
            <div class={style.userInfo}>
                <div class={style.loginBox}>
                    <Items type="horizontal" size="medium" extra={['alignCenter']}>
                        <Show when={props.state.username}>
                            <span class={style.loggedLine}><span class={style.label}>Logged in as</span> {props.state.username} |</span>
                        </Show>
                        <a href="/" class={style.homeButton}>
                            <BtnHome />
                        </a>
                        <Show when={props.state.urlLogout}>
                            <a onClick={props.onLogout} class={style.logoutButton}>
                                <BtnLogout />
                            </a>
                        </Show>
                    </Items>
                </div>
            </div>
        </Show>
    );
}

function Shell(props) {
    let notificationRenderAreaRef;
    const [isOpen, setIsOpen] = createSignal(false);

    const isMobile = mobileLayout();

    const onLogout = async () => {
        dismissAllNotificationErrors();

        const [errors] = await genRequest({
            url: props.meta.urlLogout,
            body: {},
        });

        if (errors) {
            addNotificationErrors(errors);
        }
    };

    return (
        <>
            <div class={style.shell}>
                <header class={style.header}>
                    <div class={style.logoButtons}>
                        <div class={style.shellLogo} />
                        <Show when={isMobile()}>
                            <UserInfo state={props.meta} onLogout={onLogout} />
                        </Show>
                    </div>

                    <h2 class={style.title}><span class={style.members}>Members &bull; </span>{props.meta.title}</h2>

                    <button
                        onClick={() => setIsOpen(!isOpen())}
                        classList={{[style.button]: true, [style.isOpen]: isOpen()}}
                        type="button">

                        <svg viewBox="0 0 40 40" stroke-linecap="round" stroke="white" stroke-width="4">
                            <g class={style.top}>
                                <path d="M5,20H35"/>
                            </g>
                            <g class={style.center}>
                                <path d="M5,20H35"/>
                            </g>
                            <g class={style.bottom}>
                                <path d="M5,20H35"/>
                            </g>
                        </svg>

                    </button>
                    <Show when={!isMobile()}>
                        <UserInfo state={props.meta} onLogout={onLogout} />
                    </Show>

                </header>

                <main class={style.content}>
                    <ErrorBoundary fallback={(error) => (<RenderingErrorModal state={error} meta={props.meta}/>)}>
                        {props.children}
                        <Notifications meta={props.meta} renderAreaElement={notificationRenderAreaRef}/>
                    </ErrorBoundary>
                </main>

            </div>
            <div ref={notificationRenderAreaRef}/>
        </>
    );
}

export default Shell;